/**
 * ArkType-to-Formik validation adapter.
 * Converts ArkType schema validation errors into Formik's { [field]: string } format.
 */
import { type, type Type } from "arktype";

/**
 * Creates a Formik-compatible validate function from an ArkType schema.
 */
export function arktypeToFormikValidate(schema: Type) {
  return (values: Record<string, unknown>) => {
    const result = schema(values);
    if (result instanceof type.errors) {
      const errors: Record<string, string> = {};
      for (const error of result) {
        const path = error.path.join(".");
        if (path && !errors[path]) {
          errors[path] = error.message;
        }
      }
      return errors;
    }
    return {};
  };
}
